var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2929 27.7071C15.9024 27.3166 15.9024 26.6834 16.2929 26.2929L22.5858 20L16.2929 13.7071C15.9024 13.3166 15.9024 12.6834 16.2929 12.2929C16.6834 11.9024 17.3166 11.9024 17.7071 12.2929L24.7071 19.2929C25.0976 19.6834 25.0976 20.3166 24.7071 20.7071L17.7071 27.7071C17.3166 28.0976 16.6834 28.0976 16.2929 27.7071Z",
    fill: "var(--ncap-300)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "var(--ncap-300)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSquare);
export default __webpack_public_path__ + "static/media/chevron-square.b166b2b29e93d7f4f2e6f5c4f344aa13.svg";
export { ForwardRef as ReactComponent };